import { BLANK_VALUE } from "./formatters";
import { FC, ReactNode } from "react";
import { isNil } from "../../utils/identity";
import { useTranslation } from "react-i18next";

/**
 * @returns displays a boolean value, using i18nKey to lookup the text that
 * should be displayed (i.e. Active vs Inactive, Yes vs No, etc.)
 **/
export const BooleanMeasurement: FC<{
  i18nKey?: string;
  value?: boolean | number;
}> = ({ i18nKey = "yes", value }): ReactNode => {
  const { t } = useTranslation();

  return isNil(value)
    ? BLANK_VALUE
    : t(`utils.booleans.${i18nKey}.${Boolean(value)}`);
};
